module.exports = __webpack_public_path__ + "img/DZ.0ffabba4.svg";